<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoAlert',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
})
</script>

<template>
  <div class="info-block">
    <img src="@/assets/icons/info.svg">
    <span class="info-message">{{ message }}</span>
  </div>
</template>

<style scoped></style>
